import Button from 'components/Button/Button';
import React, { useState } from 'react';
import styled from 'styled-components';
import { DownloadLogsModal } from './DownloadLogsModal';

const StyledButtonContainer = styled.div`
  margin-right: 10px;
`;

type DownloadAssetLogsProps = {
  disabled: boolean
}

export default function DownloadAssetLogs(props: DownloadAssetLogsProps) {
  const [openDownloadModal, setOpenDownloadModal] = useState(false);

  const handleDownloadLog = () => {
    setOpenDownloadModal(true);
  };

  return (
    <StyledButtonContainer>
      <Button
        id='download-logs-button'
        style={{ width: '200px' }}
        outline
        onClick={handleDownloadLog}
        disabled={props.disabled}
      >
        Download Custom Log
      </Button>
      {openDownloadModal && <DownloadLogsModal onClose={() => setOpenDownloadModal(false)} />}
    </StyledButtonContainer>
  );
}
